import React from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Hidden from '@material-ui/core/Hidden';
import { colors } from '../../../../../../constants/colors';
import { biggerThan } from '../../../../../../core/util/styledComponents';
import Button, { ButtonVariations } from '../../../../../SolvPatternLibrary/Button';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import ModalContent from './ModalContent';
import { CALL_INSURANCE_MODAL } from '../../../../../../constants/modalIds';
import useModal from '../../../../../../hooks/useModal';

const SmoothDialog = styled(Dialog).withConfig({ componentId: 'sc-1qdwh2a-0' })`
  -webkit-font-smoothing: antialiased;
  & .dialog-root {
    overflow: hidden;
    background-color: ${colors.theWhiteAlbum};

    ${biggerThan.sm`
      top: 30%;
      padding: 30px 0;
    `}
  }
`;

const Close = styled.div.withConfig({ componentId: 'sc-1qdwh2a-1' })`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 26px;
  top: 20px;
  cursor: pointer;

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.blueMonday};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.blueMonday};
  }
`;

const FlexContainer = styled.div.withConfig({ componentId: 'sc-1qdwh2a-2' })`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: 32px;
`;

const BackCta = styled(Button).withConfig({ componentId: 'sc-1qdwh2a-3' })`
  height: 32px;
  width: 68px;
  position: absolute;
  left: 12px;
  top: 10px;
  padding: 0;
  color: ${colors.crunchBerry};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.default};
`;

const Back = styled(ChevronLeft).withConfig({ componentId: 'sc-1qdwh2a-4' })`
  color: ${colors.crunchBerry};
`;

type Props = {
  open?: boolean;
  fullScreen?: boolean;
  closeModal?: (...args: any[]) => any;
  insuranceProfile?: any;
  modalValue: boolean | string;
};

const InsuranceHelpModal = (props: Props) => {
  const { modalValue, open, fullScreen, insuranceProfile } = props;

  const { closeModal } = useModal(CALL_INSURANCE_MODAL);

  return (
    <SmoothDialog
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      onClose={closeModal}
      open={!!open}
      PaperProps={{ classes: { root: 'dialog-root' } }}
      scroll="body"
      transitionDuration={{ exit: 0 }}
    >
      <Hidden xsDown>
        <Close onClick={closeModal} />
      </Hidden>

      <Hidden smUp>
        <BackCta onClick={closeModal} variation={ButtonVariations.link}>
          <Back /> Back
        </BackCta>
      </Hidden>

      <FlexContainer>
        <ModalContent insuranceProfile={insuranceProfile} modalValue={modalValue} />
      </FlexContainer>
    </SmoothDialog>
  );
};

export default withMobileDialog<Props>({ breakpoint: 'xs' })(InsuranceHelpModal);
